import { useTranslation } from 'react-i18next';

export type TerminalStatus = keyof ReturnType<typeof usePageType>;

export const PAGE_TYPE = {
    HOME: 'HOME',
    CHECKOUT: 'CHECKOUT',
    MENU: 'MENU',
};

export const usePageType = () => {
    const { t } = useTranslation();
    return {
        HOME: t('TYPES.HOME'),
        CHECKOUT: t('TYPES.CHECKOUT'),
        MENU: t('TYPES.MENU'),
    };
};

export const PAGE_TYPE_COLOR: Record<
    string,
    'success' | 'error' | 'default' | 'primary' | 'secondary' | 'info' | 'warning'
> = {
    HOME: 'secondary',
    CHECKOUT: 'info',
    MENU: 'warning',
};

export const useFilterSelectOptions = () => {
    const pageTypes = usePageType();

    return Object.keys(pageTypes).map((type) => ({
        value: type,
        label: pageTypes[type],
    }));
};
